module.exports = __webpack_public_path__ + "img/0Q3A6289_FoamcoreMatted.f8c1538d.jpg";